import { FieldArray } from "formik";
import React, { useEffect, useState } from "react";
import {
  Button,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { Delete } from "@mui/icons-material";
import { PAYMENT_STATUS_CODE } from "Components/Constants/PaymentStatusCode";
import { COLUMNS_NAME } from "Components/Constants/ColumnsNames";
import { SYSTEM_EDITIONS } from "Components/Constants/SystemEditions";
import { System } from "titum-custom/details";
import { PAYMENT_TYPE } from "Components/Constants/PaymentType";
import FormControl from "Components/MUI_components/FormControl/fomikFormControl";
import { currency } from "Components/MUI_components/currencyFormatterTag";
import SalesReturnService from "Service/Invoice/SalesReturn.service";
import { openSnackbar } from "Redux/Actions/snackbarActions";
import { TRANSACTION_CODE } from "Components/Constants/TransactionCode";
import { PAYMENT_TYPE_CODE } from "Components/Constants/PaymentTypeCode";
import giftVocuher from "Service/ADOSeries/giftVocuher.service";
import AsyncAutoComplete from "Components/MUI_components/AutoComplete/asynchronousAutoComplete";
import { VOUCHER_TYPE } from "Components/Constants/VocuhertType";
import LedgerTypesService from "Service/Accounts/LedgerTypes.service";
import { LEDGER_TYPE_GROUP } from "Components/Constants/LedgerTypeGroup";
import { LOCAL_STORAGE } from "Components/Constants/LocalStorage";
import { currentLocationCode } from "Components/Constants/ReusableFunctions";
import Input from "Components/MUI_components/FormControl/Controls/input";
import { values } from "lodash";
import { CUSTOMER_CONST } from "Components/Constants/CustomerContsnt";
import { PRINT_TYPE } from "Components/Constants/BillTemplateMode";

export default function Payments(props: any) {
  const {
    billTotal,
    isValid,
    onSubmit,
    setPrintType,
    customer,
    returnTotal,
    setReturnTotal,
    balaceWithReturn,
    invoiceValue,
    setInvoiceValue,
    setReturnCode,
    returnCode,
    royaltyAmountWithPoints,
    ledgerOptions,
    setModeOfPayment,setSms
  } = props;




  const handleRoyaltyPoints = (royaltyPoints: any) => {

    if(!royaltyPoints){
      return currency(0)
    }else {
      let point = royaltyAmountWithPoints[0].paymentPoints;
      let amount = royaltyAmountWithPoints[0].paymentAmount;
      let royaltyAmount = point / amount * royaltyPoints;
      return currency(royaltyAmount);
    }
    
  }

  const banks = useSelector((state: any) => state.bank);
  const paymentTypes = useSelector((state: any) => state.paymentType);
  const [loading, setLoading] = useState(false);

  const ledgerByPaymentType = (ledgerGroup:any) => {
  let filterdLedger =  ledgerOptions.filter((row:any)=> (
      row.ledgerGroup == ledgerGroup
    ))

    return filterdLedger;
  }

  const today = new Date().toISOString().split("T")[0];

  const dispatch = useDispatch();

  const handleVocuherType = (voucherType: number) => {
    if (voucherType == VOUCHER_TYPE.FREE_VOUCHER) {
      return "Free Vocuher"
    } else {
      return "Paid Vocuher"
    }
  }

  const initPayment = {
    amount: "",
    paidStatus: 0,
    paymentType: "",
    remarks: "",
    bankDeposit: {
      date: "",
      refNumber: "",
      bank: "",
      ledgerType: ""
    },
    chequePayment: {
      chequeDate: "",
      bank: "",
      chequeNumber: "",
    },
    cardPayment: {
      refNumber: "",
      cardNumber: "",
      bank: "",
      ledgerType: ""
    },
    giftVoucher: {

      voucherCode: ""
    },
    royaltyhPoints:{
      points:""
    }
  };
    const checkValidInvoicePhoneNumber =() => {
      if (props.customer) {
      if (props.customer?.code == CUSTOMER_CONST.CASH_CUSTOMER) {
        alert('"SMS" : Cash pay not Applicable for send Sms');
        return false;
      } else if (props.customer.phone1 == null) {  // This checks for both null and undefined
        alert("Please assign the SMS reg.number");
        return false;
      } else {
        return true;
      }
    }
  };

  const handleReturnAmount = async () => {
    try {
      setLoading(true);

      const res = await SalesReturnService.get(returnCode);

      if (!res) {
        alert("Please Enter Valid Sales Return Code");
        setLoading(false);
        setReturnCode("");
        return;
      }

      if(res.status == 5) {
        dispatch(openSnackbar("true", "info","This sales resturn already reversed"));
        setReturnCode("");
        setLoading(false);
      }else if (res.isSetteled) {
        dispatch(openSnackbar("true", "info","This sales resturn already reversed"));
        setReturnCode("");
        setLoading(false);
      } else {
        setReturnTotal(res.totalAmount);
      }

    } catch (e) {
      dispatch(openSnackbar(true, "error", e));
      setLoading(false);
    }
  };

  return (
    <FieldArray name="payment">
      {(fieldArrayProps) => {
        const { form } = fieldArrayProps;
        const { values, isSubmitting, setFieldValue } = form;

        const paymentWithoutReturn = values.modeOfPayments
          .map((payment: any) => payment.amount)
          .reduce((sum: any, i: any) => sum + i, 0);

        const paymentTotal = paymentWithoutReturn + parseFloat(returnTotal);

        let royaltyPoits = values.customer ?  values.customer.royaltyPoints : currency(0);


        return (
          <>
            <div className="row">
              <div className="col-9">
                <TextField
                  fullWidth
                  variant="outlined"
                  label="Sales Return Code"
                  value={returnCode}
                  onChange={(e: any) => setReturnCode(e.target.value)}
                />
              </div>
              <div className="col-3">
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleReturnAmount}
                  disabled={loading || !returnCode}
                >
                  Return Amount
                </Button>
              </div>
            </div>
            <div className="row" style={{ marginTop: 20, marginBottom: 20 }}>
              <div className="col-12">
                <TextField
                  variant="standard"
                  fullWidth
                  label="Bill Total"
                  value={currency(billTotal)}
                  disabled
                />
              </div>
              <div className="col-12">
                <TextField
                  variant="standard"
                  fullWidth
                  label="Return Total"
                  value={currency(returnTotal)}
                  disabled
                />
              </div>
              <div className="col-12">
                <TextField
                  variant="standard"
                  fullWidth
                  label="Balance"
                  value={currency(billTotal - paymentTotal)}
                  disabled
                />
              </div>
            </div>

            <div className="row">
              <div className="col-6">
                <FormControl
                  control="select"
                  label="Payment Type"
                  options={paymentTypes}
                  name="payment.paymentType"
                />
              </div>
              <div className="col-6">
                <FormControl
                  disabled={values.payment.paymentType == PAYMENT_TYPE_CODE.GIFT_VOUCHER_PAYMENT || values.payment.paymentType == PAYMENT_TYPE_CODE.ROYALTY_POINTS}
                  control="currency"
                  nested
                  name="payment.amount"
                  label={`Paid Amount ${values.payment.paymentType ==
                    paymentTypes.filter(
                      (paymentType: any) => paymentType.name == PAYMENT_TYPE.OVER_PAYMENT
                    )[0]?.code
                    ? values.customer?.overPayment
                    : values.payment.paymentType ==
                      paymentTypes.filter(
                        (paymentType: any) => paymentType.name == PAYMENT_TYPE.RETURN_AMOUNT
                      )[0]?.code
                      ? values.customer?.returnAmount
                      : ""
                    }`}
                />
              </div>
            </div>
            {values.payment.paymentType && (
              <>
                {values.payment.paymentType ===
                  paymentTypes.filter(
                    (paymentType: any) => paymentType.name === "Cheque"
                  )[0]?.code && (
                    <FieldArray name="payment.chequePayment">
                      {(chequePaymentProps) => {
                        return (
                          <div className="row">
                            <div className="col-4">
                              <FormControl
                                control="select"
                                label="Bank"
                                options={banks}
                                name="payment.chequePayment.bank"
                              />
                            </div>
                            <div className="col-4">
                              <FormControl
                                control="input"
                                label="Cheque Number"
                                name="payment.chequePayment.chequeNumber"
                              />
                            </div>
                            <div className="col-4">
                              <FormControl
                                control="input"
                                type="date"
                                label="Cheque Date"
                                name="payment.chequePayment.date"
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                inputProps={{
                                  min: today,
                                }}
                              />
                            </div>
                          </div>
                        );
                      }}
                    </FieldArray>
                  )}
                {values.payment.paymentType ===
                  paymentTypes.filter(
                    (paymentType: any) => paymentType.name === "Bank Deposit/Transfer"
                  )[0]?.code && (
                    <FieldArray name="payment.bankDeposit">
                      {(bankDepositProps) => {
                        return (
                          <>
                            <div className="row">
                              <div className="col-6">
                                <FormControl
                                  control="select"
                                  label="Bank"
                                  options={banks}
                                  name="payment.bankDeposit.bank"
                                />
                              </div>
                              <div className="col-6">
                                <FormControl
                                  control="autoComplete"
                                  name="payment.bankDeposit.ledgerType"
                                  withoutLocationFilter
                                  label="Ledger Type (Bank)"
                                  getOptionLabel={(option:any) =>
                                  option.name + "-" + option.code
                                 }
                                  options={ledgerByPaymentType(LEDGER_TYPE_GROUP.BANK)}
                                />
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-6">
                                <FormControl
                                  control="input"
                                  label="Ref Number"
                                  name="payment.bankDeposit.refNumber"
                                />
                              </div>
                              <div className="col-6">
                                <FormControl
                                  control="input"
                                  name="payment.bankDeposit.date"
                                  label="Deposited Date"
                                  type="date"
                                  InputLabelProps={{
                                    shrink: true,
                                  }}
                                />
                              </div>
                            </div>
                          </>
                        );
                      }}
                    </FieldArray>
                  )}
                {values.payment.paymentType ===
                  paymentTypes.filter(
                    (paymentType: any) => paymentType.name === "Card"
                  )[0]?.code && (
                    <FieldArray name="payment.cardPayment">
                      {(cardPaymentProps) => {
                        return (
                          <>
                            <div className="row">
                              <div className="col-6">
                                <FormControl
                                  control="select"
                                  label="Bank"
                                  options={banks}
                                  name="payment.cardPayment.bank"
                                />
                              </div>
                              <div className="col-6">
                                <FormControl
                                  control="input"
                                  label="Ref Number"
                                  name="payment.cardPayment.refNumber"
                                />
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-6">
                                <FormControl
                                  control="autoComplete"
                                  name="payment.cardPayment.ledgerType"
                                  label="Ledger Type (Credit Card)"
                                  withoutLocationFilter
                                  getOptionLabel={(option:any) =>
                                  option.name + "-" + option.code
                                 }
                                  options={ledgerByPaymentType(LEDGER_TYPE_GROUP.CREDIT_CARD)}
                                />
                              </div>
                              <div className="col-6">
                                <FormControl
                                  control="number"
                                  label="Card Number (Last 4 digit)"
                                  name="payment.cardPayment.cardNumber"
                                />
                              </div>
                            </div>
                          </>
                        );
                      }}
                    </FieldArray>
                  )}
                {values.payment.paymentType ===
                  paymentTypes.filter(
                    (paymentType: any) => paymentType.name === "Gift Voucher"
                  )[0]?.code && (
                    <FieldArray name="payment.giftVocuherPayment">
                      {(chequePaymentProps) => {
                        return (
                          <div className="row">
                            <div className="col-12">
                              <AsyncAutoComplete
                                inputProps={{
                                  label: "Gift Voucher",
                                }}
                                name="payment.giftVoucher.voucherCode"
                                stockValidate={false}
                                Service={giftVocuher.issuedVocuherSearch}
                                getOptionLabel={(option: any) =>
                                  option.code + " - " + option.amount + " - " + handleVocuherType(option.voucherType)
                                }
                                withoutLocationFilter
                                onChange={(e: any, newValue: any) => {
                                  if (newValue) {
                                    setFieldValue("payment.giftVoucher", newValue);
                                    setFieldValue("payment.amount", newValue.amount || 0);
                                  } else {
                                    setFieldValue("payment.giftVoucher", null);
                                    setFieldValue("payment.amount", 0);
                                  }
                                }}
                              />
                            </div>
                          </div>
                        );
                      }}
                    </FieldArray>
                  )}
                  {values.payment.paymentType ===
                  paymentTypes.filter(
                    (paymentType: any) => paymentType.name === "Royalty Points"
                  )[0]?.code && (
                    <FieldArray name="payment.royaltyhPoints">
                      {(chequePaymentProps) => {
                        return (
                          <div className="row">
                            <div className="col-12">
                             <FormControl
                                control="input"
                                name="payment.royaltyhPoints.points"
                                label={`Points ${values.payment.paymentType ==
                                        paymentTypes.filter(
                                          (paymentType: any) => paymentType.name == PAYMENT_TYPE.ROYALTY_POINTS
                                        )[0]?.code
                                        ? "(R.P:" + royaltyPoits + " - " + "Amount : " + handleRoyaltyPoints(parseFloat(values.customer?.royaltyPoints)) + ")"
                                        : ""}`}
                                      onChange={(e:any) => {
                                  const newValue = e.target.value;
                                  if (newValue) {
                                    setFieldValue("payment.royaltyhPoints.points", newValue);
                                    let amount = handleRoyaltyPoints(newValue);
                                    setFieldValue("payment.amount", amount || 0);
                                  } else {
                                    setFieldValue("payment.giftVoucher", null);
                                    setFieldValue("payment.amount", 0);
                                  }
                                }}       
                              />
                            </div>
                          </div>
                        );
                      }}
                    </FieldArray>
                  )}
              </>
            )}
            <div className="row">
              <div className="col-12">
                <FormControl
                  control="input"
                  name="payment.remarks"
                  label="Remarks"
                />
              </div>
            </div>
            <FieldArray name="modeOfPayments">
              {({ push, remove }) => (
                <>
                  <div className="row flex-end mb">
                    <Button
                      disabled={
                        !values.payment.amount ||
                        !values.payment.paymentType ||
                        (values.payment.paymentType == PAYMENT_TYPE_CODE.CHEQUE_PAYMENT &&
                          (!values.payment.chequePayment.bank ||
                            !values.payment.chequePayment.chequeNumber ||
                            !values.payment.chequePayment.date)) ||
                        (values.payment.paymentType == PAYMENT_TYPE_CODE.BANK_DEPOSIT &&
                          (!values.payment.bankDeposit.bank ||
                            !values.payment.bankDeposit.refNumber ||
                            !values.payment.bankDeposit.date)) ||
                        (values.payment.paymentType == PAYMENT_TYPE_CODE.CARD_PAYMENT &&
                          (!values.payment.cardPayment.bank ||
                            !values.payment.cardPayment.refNumber ||
                            !values.payment.cardPayment.cardNumber ||
                            !values.payment.cardPayment.ledgerType)) 
                      }
                      variant="contained"
                      onClick={() => {

                        let totalRoyaltyPoints = handleRoyaltyPoints(values.customer?.royaltyPoints);
                        

                        if (
                          (values.payment.paymentType ==
                          paymentTypes.filter(
                            (paymentType: any) => paymentType.name == PAYMENT_TYPE.ROYALTY_POINTS
                          )[0]?.code) && values.payment.amount > totalRoyaltyPoints

                        ) {
                          dispatch(openSnackbar(true, "error", "The value entered is greater than available amount"));
                          return;
                        }else if((values.payment.paymentType ==
                          paymentTypes.filter(
                            (paymentType: any) => paymentType.name == PAYMENT_TYPE.ROYALTY_POINTS
                          )[0]?.code)) {
                        values.customer = {
                          ...values.customer,
                          royaltyPoints: values.customer.royaltyPoints -  values.payment.royaltyhPoints.points,
                        }}

                        if ((values.payment.paymentType ==
                          paymentTypes.filter(
                            (paymentType: any) => paymentType.name == PAYMENT_TYPE.ROYALTY_POINTS
                          )[0]?.code) && !values.customer
                        ) {
                          dispatch(openSnackbar(true, "error", "Please Select Customer"));
                          return;
                        }

                        if ((values.payment.paymentType ==
                          paymentTypes.filter(
                            (paymentType: any) => paymentType.name == PAYMENT_TYPE.OVER_PAYMENT
                          )[0]?.code) && values.payment.amount > values.customer.overPayment
                        ) {
                          alert("The value entered is greater than available amount");
                          return;
                        } else if ((values.payment.paymentType ==
                          paymentTypes.filter(
                            (paymentType: any) => paymentType.name == PAYMENT_TYPE.OVER_PAYMENT
                          )[0]?.code) && values.payment.amount <= values.customer.overPayment
                        ) {
                          values.customer.overPayment = values.customer.overPayment - values.payment.amount
                        }

                        if ((values.payment.paymentType ==
                          paymentTypes.filter(
                            (paymentType: any) => paymentType.name == PAYMENT_TYPE.RETURN_AMOUNT
                          )[0]?.code) && values.payment.amount > values.customer.returnAmount
                        ) {
                          alert("The value entered is greater than available amount");
                          return;
                        }
                        else if ((values.payment.paymentType ==
                          paymentTypes.filter(
                            (paymentType: any) => paymentType.name == PAYMENT_TYPE.RETURN_AMOUNT
                          )[0]?.code) && values.payment.amount <= values.customer.returnAmount
                        ) {
                          values.customer.returnAmount = values.customer.returnAmount - values.payment.amount
                        }
                        push({
                          ...values.payment,
                        });
                        setFieldValue("payment", initPayment);
                        setFieldValue("payment.amount", "");
                        setFieldValue("payment.remarks", "");
                      }}
                      color="secondary"
                    >
                      Add
                    </Button>
                  </div>

                  <div className="row">
                    <TableContainer>
                      <Table
                        aria-labelledby="tableTitle"
                        size={"small"}
                        aria-label="enhanced table"
                      >
                        <TableHead style={{ backgroundColor: "#eee" }}>
                          <TableRow hover role="checkbox" tabIndex={-1}>
                            <TableCell width={10}></TableCell>
                            <TableCell>#</TableCell>
                            <TableCell>{COLUMNS_NAME.REMARKS}</TableCell>
                            <TableCell>{COLUMNS_NAME.PAYEMENT_TYPE}</TableCell>
                            <TableCell align="right">{COLUMNS_NAME.SETTELED_AMOUNT}</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {values.modeOfPayments.map(
                            (payment: any, index: any) => (
                              <TableRow
                                role="checkbox"
                                tabIndex={-1}
                                key={index}
                              >
                                <TableCell width={10}>
                                  <Delete
                                    color="secondary"
                                    style={{
                                      fontSize: 18,
                                      cursor: "pointer",
                                    }}
                                    onClick={() => {
                                      if (
                                        window.confirm(
                                          "Are you sure want to delete this?"
                                        )
                                      ) {
                                        remove(index);
                                      }
                                    }}
                                  />
                                </TableCell>
                                <TableCell width={10}>{index + 1}</TableCell>
                                <TableCell>{payment.remarks}</TableCell>
                               <TableCell>
                                  {paymentTypes.find(
                                    (paymentType: any) => paymentType.code === payment.paymentType
                                  )?.name || "N/A"}
                                </TableCell>

                                <TableCell align="right">
                                  {currency(payment.amount)}
                                </TableCell>
                              </TableRow>
                            )
                          )}
                          {!values.modeOfPayments.length ? (
                            <TableRow>
                              <TableCell colSpan={5} align="center">
                                No items to display
                              </TableCell>
                            </TableRow>
                          ) : (
                            <TableRow>
                              <TableCell colSpan={3} />
                              <TableCell align="left">
                                <strong>Total</strong>
                              </TableCell>
                              <TableCell align="right">
                                <strong>{currency(paymentTotal)}</strong>
                              </TableCell>
                            </TableRow>
                          )}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </div>
                </>
              )}
            </FieldArray>

            {System.SYSTEM_EDITION === SYSTEM_EDITIONS.BIZ_X_AUTO_CARE ? (
              <div className="flex" style={{ margin: 20 }}>
                <button
                  type="button"
                  disabled={
                    !returnTotal ? isSubmitting || !values.modeOfPayments.length || currency(billTotal) < paymentTotal :
                      isSubmitting || currency(billTotal) < paymentTotal}
                  onClick={() => {
                    if (billTotal > paymentTotal) {
                      if (window.confirm(`Invoice Total : ${currency(billTotal)}\nPaid Total : ${currency(paymentTotal)}
                        \nBlalance: ${currency(billTotal - paymentTotal)}`)) {
                        setPrintType('DOT');
                        onSubmit();
                      }
                    } else {
                      setPrintType('DOT');
                      onSubmit();
                    }
                  }}
                  className="btn-success button"
                >
                  PrintBill
                  <span>
                    {isSubmitting ? (
                      <CircularProgress
                        color="inherit"
                        size={20}
                      />
                    ) : (
                      ""
                    )}
                  </span>
                </button>
              </div>
            ) : (
              <div className="flex" style={{ margin: 20 }}>
                 {/* <button
                type="button"
                disabled={
                  isSubmitting || !values.modeOfPayments.length || billTotal < paymentTotal
                }
                onClick={() => {
                  if (checkValidInvoicePhoneNumber()) {
                    setModeOfPayment(true);
                    setPrintType(PRINT_TYPE.POS);
                    onSubmit();
                    setSms(false);
                  }
                }}
                className="btn-success button"
              >
                pos + SMS
                <span>
                  {isSubmitting ? (
                    <CircularProgress
                      color="inherit"
                      size={20}
                    />
                  ) : (
                    " "
                  )}
                </span>
              </button> 

              <button
                type="button"
                disabled={
                  isSubmitting || !values.modeOfPayments.length || billTotal < paymentTotal
                }
                onClick={() => {
                  if (checkValidInvoicePhoneNumber()) {
                    setModeOfPayment(true);
                    setPrintType(PRINT_TYPE.DOT_MATRIX);
                    onSubmit();
                    setSms(false);
                  }
                  
                 
                }}
                className="btn-success button"
              >
                Dot + SMS
                <span>
                  {isSubmitting ? (
                    <CircularProgress
                      color="inherit"
                      size={20}
                    />
                  ) : (
                    ""
                  )}
                </span>
              </button> */}
                <button
                  type="button"
                  disabled={
                    !returnTotal ? isSubmitting || !values.modeOfPayments.length || currency(billTotal) < paymentTotal :
                      isSubmitting || currency(billTotal) < paymentTotal}
                  onClick={() => {
                  setPrintType(PRINT_TYPE.POS);
                  onSubmit();
                  setModeOfPayment(false);
                  setSms(false);

                }}

                  className="btn-success button"
                >
                  pos bill
                  <span>
                    {isSubmitting ? (
                      <CircularProgress
                        color="inherit"
                        size={20}
                      />
                    ) : (
                      "[ Enter ]"
                    )}
                  </span>
                </button>

                <button
                  type="button"
                  disabled={
                    !returnTotal ? isSubmitting || !values.modeOfPayments.length || currency(billTotal) < paymentTotal :
                      isSubmitting || currency(billTotal) < paymentTotal}
                  onClick={() => {
                    if (billTotal > paymentTotal) {
                      if (window.confirm(`Invoice Total : ${currency(billTotal)}\nPaid Total : ${currency(paymentTotal)}\nBlalance: ${currency(billTotal - paymentTotal)}`)) {
                           {
                  setPrintType(PRINT_TYPE.DOT_MATRIX);
                  onSubmit();
                  setModeOfPayment(false);
                  setSms(false);
                }
                      }
                    } else {
                      {
                  setPrintType(PRINT_TYPE.DOT_MATRIX);
                  onSubmit();
                  setModeOfPayment(false);
                  setSms(false);
                }
                    }
                  }}
                  className="btn-success button"
                >
                  Print bill
                  <span>
                    {isSubmitting ? (
                      <CircularProgress
                        color="inherit"
                        size={20}
                      />
                    ) : (
                      ""
                    )}
                  </span>
                </button>
              </div>
            )}
          </>
        );
      }}
    </FieldArray>
  );
}
